import { FC, useState } from "react";
import close from "../../../images/close.svg";

const TermsConditionsModal: FC<TermsConditionsModalProps> = ({
  onAccept,
  onClose,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(e.target.checked);
  };

  const handleAcceptClick = () => {
    if (isChecked) {
      onAccept();
    } else {
      // Optionally, you can show a warning or feedback to the user here.
      alert("Please agree to the Terms and Conditions.");
    }
  };

  return (
    <div className="flex flex-col items-center text-center w-[calc(100%-48px)] max-w-[420px] sm:w-[490px] sm:max-w-[490px] bg-white py-[40.5px] px-8 xs:py-[49px] xs:px-[35.5px] rounded-[20px] relative text-gray-7">
      <img
        className="absolute top-8 right-[26px] cursor-pointer"
        src={close}
        alt="close"
        onClick={onClose}
      />

      <h1 className="font-extrabold text-[28px] leading-[32px] xs:text-[35px] xs:leading-[37px] mb-4">
        Accept Terms and Conditions
      </h1>

      <div className="flex flex-col gap-[23px] mb-4 font-[400] text-[14px] xs:text-base leading-[20px]">
        <p className="">
          By clicking the checkbox below, you agree to abide by our{" "}
          <a
            href="/terms"
            target="_blank"
            rel="noreferrer"
            className="underline"
          >
            Terms and Conditions of Use
          </a>
          .
        </p>

        <p className="">Please review the terms carefully before proceeding.</p>
      </div>

      <label className="flex items-center self-start gap-2 text-[12px] xxs:text-[14px] leading-[18px] mb-11">
        <input
          onChange={handleCheckboxChange}
          type="checkbox"
          checked={isChecked}
          className="w-[18px] h-[18px] cursor-pointer"
        />
        I agree to the Terms and Conditions
      </label>

      <button
        className="bg-gray-7 text-white font-[900] rounded-[24px] py-[15px] max-w-[calc(100%-64px)] w-[305px] text-base leading-[20px] xs:text-[18px] xs:leading-[22px] disabled:cursor-not-allowed"
        disabled={!isChecked}
        onClick={handleAcceptClick}
      >
        Continue
      </button>
    </div>
  );
};

export default TermsConditionsModal;

interface TermsConditionsModalProps {
  onAccept: () => void;
  onClose: () => void;
}
